module.exports = __webpack_public_path__ + "static/media/activity-light.8401d4bb.svg";